import {
  createYoutrustIntegration,
  deleteYoutrustIntegration,
  getYoutrustStatus,
  type ApplicationMessage,
  type YoutrustIntegrationInDb,
  type YoutrustIntegrationStatus,
} from '@/api';
import { extractErrorDetail } from '@/utils/errorHandler';

export async function createYoutrustSigningIntegration(
  management_api_key: string,
  signing_api_key: string
): Promise<YoutrustIntegrationInDb> {
  const response = await createYoutrustIntegration({
    body: {
      signing_api_key,
      management_api_key,
    },
  });

  if (response.error) {
    throw new Error(
      extractErrorDetail(response.error, 'Failed to connect the Youtrust integration.')
    );
  }

  return response.data;
}

export async function fetchYoutrustSigningIntegrationStatus(): Promise<YoutrustIntegrationStatus> {
  const { data } = await getYoutrustStatus({ throwOnError: true });
  return data;
}

export async function removeYoutrustSigningIntegration(): Promise<ApplicationMessage> {
  const { data } = await deleteYoutrustIntegration({ throwOnError: true });
  return data;
}
